import {InitiatedBookingActionTypes} from "./actionTypes";

export const getInitiatedBookings = (payload) => {
  return {
    type: InitiatedBookingActionTypes.INITIATED_BOOKING_LIST_GET,
    payload: payload,
  };
};

export const getInitiatedBookingsSuccessful = (payload) => {
  return {
    type: InitiatedBookingActionTypes.INITIATED_BOOKING_LIST_GET_SUCCESSFUL,
    payload: payload,
  };
};

export const getInitiatedBookingsError = (payload) => {
  return {
    type: InitiatedBookingActionTypes.INITIATED_BOOKING_LIST_GET_ERROR,
    payload,
  };
};

export const setInitiatedBookingQuery = (payload) => {
  return {
    type: InitiatedBookingActionTypes.SET_INITIATED_BOOKING_QUERY,
    payload,
  };
};

export const resetInitiatedBookingQuery = () => {
  return {
    type: InitiatedBookingActionTypes.RESET_INITIATED_BOOKING_QUERY,
  };
};
